import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {Booking} from '../../core/Booking';
import {Pet} from '../../shared/pets/pet';
import {FormControl, FormGroup, Validators, FormBuilder, FormArray} from '@angular/forms';
import {HIUser} from '../../core/HIUser';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { NoteType } from './NoteType';
import { PetNote } from './PetNote';
import { ImageUploadService } from '../image-upload/image-upload.service';
import { ImageUpload } from 'src/app/core/ImageUpload';
import {UploadService} from '../../services/upload.service';

@Component({
  selector: 'pet-detail',
  templateUrl: './pet-detail.component.html',
  styleUrls: ['./pet-detail.component.css']
})
export class PetDetailComponent implements OnChanges {
  @Input()  pet: Pet;
  @Output() savedPet: EventEmitter<Pet> = new EventEmitter();
    protected selectedPets = new Array<number>();
    petForm: FormGroup;

    petNoteTypes = NoteType;
    petNoteTypesKeys: any[];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['pet']) {
            this.petForm.patchValue(changes.pet.currentValue);
            const controlArray = <FormArray>this.petForm.controls['notes'];
            controlArray.clear();
            if (changes.pet.currentValue.notes) {
              changes.pet.currentValue.notes.forEach(app => {
                const fb = this.createNotes();
                fb.patchValue(app);
                controlArray.push(fb);
              });
            }
        }
    }

  constructor(private formBuilder: FormBuilder,
              private s3Service: UploadService,
    private imageUploadService: ImageUploadService, ) {
    this.petForm = this.formBuilder.group({
      name: ['', Validators.required],
      type: ['', Validators.required],
      breed: [''],
      notes: this.formBuilder.array([])
    });
    this.petNoteTypesKeys = Object.keys(this.petNoteTypes).filter(x => String(x).length > 2);
    this.imageUploadService.image$.subscribe( image => {
      this.updatePetWithImage(image);
    });
}

updatePetWithImage(image: ImageUpload) {
  this.pet.pic = image.savedFileName;
}

  get notes() {
    return this.petForm.get('notes') as FormArray;
  }
  addItem() {
    this.notes.push(this.createNotes());
 }
 removeItem(index: number) {
  this.notes.removeAt(index);
}

  createNotes(): FormGroup {
    return this.formBuilder.group({
        sid: [''],
        type: [''],
        note: ['']
    });
  }
    onSubmit() {
        this.pet.name = this.petForm.get('name').value;
        this.pet.type = this.petForm.get('type').value;
        this.pet.breed = this.petForm.get('breed').value;
        this.pet.notes = [];
        for (const note of this.notes.controls) {
          const newNote: PetNote = new PetNote(note.value.sid, note.value.note, note.value.type);
          this.pet.notes.push(newNote);
      }
        this.savedPet.next(this.pet);
    }

    imageUploaded(files) {
        const allFiles = JSON.parse(JSON.stringify(files));
        const image_extentions = ['jpg', 'png', 'gif', 'webp', 'tiff', 'psd', 'raw', 'bmp', 'jpeg', 'svg'];
        for (let i = 0; i < allFiles.length; i++ ) {
            const file = allFiles[i];
            const splitKey = file.name.split('.');
            file.extention = splitKey[1].toLowerCase();
            file.type = image_extentions.includes(file.extention) ? 'image' : 'other';
        }
        this.pet.files = allFiles;
    }

    deleteFile(key, i) {
        this.s3Service.deleteFile(key);
        this.pet.files.splice(i, 1);
    }
}
